import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Checkmark = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7334 3.2243C14.0279 3.44528 14.0875 3.86317 13.8665 4.15766L7.56336 12.5574C7.24578 12.9806 6.62923 13.0298 6.24847 12.6625L2.20376 8.75985C1.9388 8.50419 1.93126 8.08215 2.18691 7.81719C2.44256 7.55223 2.8646 7.54469 3.12957 7.80034L6.80494 11.3466L12.8001 3.35739C13.0211 3.06289 13.4389 3.00331 13.7334 3.2243Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Checkmark;
